import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row mt-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Name")
], -1)
const _hoisted_4 = { class: "col-10" }
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Subject")
], -1)
const _hoisted_8 = { class: "col-10" }
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = { class: "row mt-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Body")
], -1)
const _hoisted_12 = { class: "col-10" }
const _hoisted_13 = { class: "row mt-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Include domains")
], -1)
const _hoisted_15 = { class: "col-10" }
const _hoisted_16 = { class: "row mt-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Exclude domains")
], -1)
const _hoisted_18 = { class: "col-10" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-12 d-flex justify-content-end mt-3" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick", "disabled"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 0,
  class: "w-100"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Name ")
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Subject ")
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Body ")
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Date Created ")
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "col-2" }
const _hoisted_35 = { class: "col-4" }
const _hoisted_36 = { class: "col-4 m-0" }
const _hoisted_37 = {
  key: 0,
  class: "border bg-gray-50"
}
const _hoisted_38 = { class: "col-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ckeditor = _resolveComponent("ckeditor")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_SortIcon = _resolveComponent("SortIcon")!
  const _component_RenderHtml = _resolveComponent("RenderHtml")!
  const _component_List = _resolveComponent("List")!

  return (_openBlock(), _createBlock(_component_List, {
    name: _ctx.name,
    actions: _ctx.autoReplyActions,
    resolveState: _ctx.resolveState
  }, {
    edit: _withCtx(({ selectedItem, addItem, updateItem, deleteItem }) => [
      selectedItem
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  required: "",
                  "onUpdate:modelValue": ($event: any) => ((selectedItem.name) = $event)
                }, null, 8, _hoisted_5), [
                  [_vModelText, selectedItem.name]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  required: "",
                  "onUpdate:modelValue": ($event: any) => ((selectedItem.subject) = $event)
                }, null, 8, _hoisted_9), [
                  [_vModelText, selectedItem.subject]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_ckeditor, {
                  editor: _ctx.editor,
                  modelValue: selectedItem.body,
                  "onUpdate:modelValue": ($event: any) => ((selectedItem.body) = $event)
                }, null, 8, ["editor", "modelValue", "onUpdate:modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_AutoComplete, {
                  modelValue: selectedItem.includeDomains,
                  "onUpdate:modelValue": ($event: any) => ((selectedItem.includeDomains) = $event),
                  suggestions: _ctx.domains,
                  multiple: true,
                  autoHighlight: true,
                  dropdown: true,
                  completeOnFocus: true,
                  forceSelection: true,
                  onComplete: _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchDomains($event.query))),
                  field: "name"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "suggestions"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_AutoComplete, {
                  modelValue: selectedItem.excludeDomains,
                  "onUpdate:modelValue": ($event: any) => ((selectedItem.excludeDomains) = $event),
                  suggestions: _ctx.domains,
                  multiple: true,
                  autoHighlight: true,
                  dropdown: true,
                  completeOnFocus: true,
                  onComplete: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchDomains($event.query))),
                  field: "name"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "suggestions"])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                (selectedItem?.id != null && selectedItem.name !== 'Inbox')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-danger mr-1",
                      onClick: _withModifiers(($event: any) => (deleteItem(selectedItem.name)), ["prevent"])
                    }, " Delete " + _toDisplayString(_ctx.name), 9, _hoisted_21))
                  : _createCommentVNode("", true),
                (selectedItem?.id == null)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn btn-primary",
                      onClick: _withModifiers(addItem, ["prevent"]),
                      disabled: selectedItem?.name && selectedItem.name.length === 0
                    }, " Add " + _toDisplayString(_ctx.name), 9, _hoisted_22))
                  : _createCommentVNode("", true),
                (selectedItem?.id != null)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      class: "btn btn-primary",
                      onClick: _withModifiers(updateItem, ["prevent"])
                    }, " Update " + _toDisplayString(_ctx.name), 9, _hoisted_23))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    list: _withCtx(({
        selectedItem,
        items,
        setSelected,
        setSort,
        sortBy,
        sortByDescending
      }) => [
      (items.length > 0)
        ? (_openBlock(), _createElementBlock("table", _hoisted_24, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  class: "cursor-pointer",
                  onClick: _withModifiers(($event: any) => (setSort('Name')), ["prevent"])
                }, [
                  _hoisted_26,
                  _createVNode(_component_SortIcon, {
                    sortBy: sortBy,
                    sortByDescending: sortByDescending,
                    field: "Name"
                  }, null, 8, ["sortBy", "sortByDescending"])
                ], 8, _hoisted_25),
                _createElementVNode("th", {
                  class: "cursor-pointer",
                  onClick: _withModifiers(($event: any) => (setSort('Subject')), ["prevent"])
                }, [
                  _hoisted_28,
                  _createVNode(_component_SortIcon, {
                    sortBy: sortBy,
                    sortByDescending: sortByDescending,
                    field: "Subject"
                  }, null, 8, ["sortBy", "sortByDescending"])
                ], 8, _hoisted_27),
                _createElementVNode("th", {
                  class: "cursor-pointer",
                  onClick: _withModifiers(($event: any) => (setSort('Body')), ["prevent"])
                }, [
                  _hoisted_30,
                  _createVNode(_component_SortIcon, {
                    sortBy: sortBy,
                    sortByDescending: sortByDescending,
                    field: "Body"
                  }, null, 8, ["sortBy", "sortByDescending"])
                ], 8, _hoisted_29),
                _createElementVNode("th", {
                  class: "cursor-pointer",
                  onClick: _withModifiers(($event: any) => (setSort('DateCreated')), ["prevent"])
                }, [
                  _hoisted_32,
                  _createVNode(_component_SortIcon, {
                    sortBy: sortBy,
                    sortByDescending: sortByDescending,
                    field: "DateCreated"
                  }, null, 8, ["sortBy", "sortByDescending"])
                ], 8, _hoisted_31)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cast(items), (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id,
                  class: _normalizeClass(item.id == selectedItem?.id ? 'selected-row' : ''),
                  onClick: _withModifiers(($event: any) => (setSelected(item)), ["prevent"])
                }, [
                  _createElementVNode("td", _hoisted_34, _toDisplayString(item.name), 1),
                  _createElementVNode("td", _hoisted_35, _toDisplayString(item.subject), 1),
                  _createElementVNode("td", _hoisted_36, [
                    (!!item.body)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createVNode(_component_RenderHtml, {
                            html: item.body
                          }, null, 8, ["html"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.$filters.dateTime(item.dateCreated)), 1)
                ], 10, _hoisted_33))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["name", "actions", "resolveState"]))
}